export default "__VITE_ASSET__wCdToXRw__"